import feature from 'vue-feature-toggle';
import * as types from './types';

const getters = {
  [types.GET_IS_MANAGED_ACCOUNT]: (state) => feature.isVisible('MANAGED_CAMPAIGNS') || state.features.includes('MANAGED_CAMPAIGNS'),
  [types.GET_PROFILE_PROPERTIES]: (state) => state.properties ?? {},
};

export default getters;
